import script from "./EligibilityToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./EligibilityToggle.vue?vue&type=script&setup=true&lang=js"

import "./EligibilityToggle.vue?vue&type=style&index=0&id=731bad4c&scope=true&lang=scss"

export default script